import {
  NavLink as RouterLink,
  matchPath,
  useLocation
} from 'react-router-dom';
import PropTypes from 'prop-types';
import { Button, ListItem, Box } from '@mui/material';
import React, { useState } from "react";
import SubMenu from "./SubMenu";

const NavItem = ({
  href,
  icon: Icon,
  title,
  hide,
  newTab,
  config,
  is_external,
  showlog,
  ...rest
}) => {
  const { pathname } = useLocation();
  const [subnav, setSubnav] = useState(false);
  const showSubnav = () => setSubnav(!subnav);
  const active = href ? !!matchPath({
    path: href,
    end: false
  }, pathname) : false;
  const capitalizeFirstLowercaseRest = str => {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };
  const openNewTab = (val) => {
    if (newTab) {
      const newWindow = window.open(val, '_blank', 'noopener,noreferrer')
      if (newWindow) newWindow.opener = null
    } else if (is_external) {
      const newWindow = window.open(val, '_self', 'noopener,noreferrer')
      if (newWindow) newWindow.opener = null
    }
  }
  return (
    <ListItem
      disableGutters
      sx={{
        display: 'flex',
        py: 0
      }}
      {...rest}
    >
      <Button
        component={RouterLink}
        sx={{
          color: 'white.main',
          fontWeight: 'medium',
          justifyContent: 'flex-start',
          display: hide !== undefined && hide === false ? "none" : href === "" ? "none" : "",
          letterSpacing: 0,
          py: 1.25,
          textTransform: config ? 'capitalize' : 'none',
          width: '100%',
          ...(active && {
            backgroundColor: 'red.main'
          }),
          '& svg': {
            mr: 1
          },
          pointerEvents: href === "" ? "none" : "auto",
          opacity: href === "" ? "50%" : "100%",
          // '& span:first-letter': { textTransform: 'capitalize' }
        }}
        onClick={() => newTab ? openNewTab(href) : is_external ? openNewTab(href) : null}
        to={newTab ? "" : is_external ? "" : href}
        target={newTab ? "_blank" : "_self"}
        rel="noopener,noreferrer"
      >
        <Box sx={{ marginRight: "10px", display: "flex", alignItems: "center" }}>
          <img style={{ fontSize: "18px" }} src={Icon} />
        </Box>
        <span id="textMenu" style={{
          fontSize: "16px", fontWeight: "500"
          // , textTransform: 'lowercase', display: "inline-block"
        }}>
          {config ?
            capitalizeFirstLowercaseRest(title)
            :
            title
          }
        </span>
      </Button>
    </ListItem>
  );
};

NavItem.propTypes = {
  href: PropTypes.string,
  icon: PropTypes.elementType,
  title: PropTypes.string,
  height: PropTypes.bool,
};

export default NavItem;
